import { render, staticRenderFns } from "./orderitems.vue?vue&type=template&id=9f15e170&scoped=true&"
import script from "./orderitems.vue?vue&type=script&lang=js&"
export * from "./orderitems.vue?vue&type=script&lang=js&"
import style1 from "./orderitems.vue?vue&type=style&index=1&id=9f15e170&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f15e170",
  null
  
)

export default component.exports